import BUMPHero from './BUMPHero';

export default BUMPHero;
